export default __webpack_public_path__ + "static/media/trade-tracker-preview.bded50e4.png";